<div class="api-listener-section">
  <div class="info-section box-light-grey">
    <h4>API Listener Details</h4>
    <div class="info-grid">
      <div class="info-item">
        <span class="info-label">Last Updated:</span>
        <span class="info-value">{{ dataSource.updatedAt | date:'yyyy-MM-dd HH:mm' }}</span>
      </div>
    </div>
  </div>

  <div class="api-config-section box-light-grey">
    <h4>API Configuration</h4>
    <p class="helper-text">Use these details to send data to this API Listener</p>

    <div class="config-item">
      <label>Endpoint</label>
      <div class="input-with-copy">
        <input type="text" 
               [value]="endpoint" 
               readonly 
               (click)="selectText($event)">
        <button mat-raised-button 
                color="primary" 
                (click)="copyToClipboard(endpoint)">
          Copy
        </button>
      </div>
    </div>

    <div class="config-item">
      <label>Token</label>
      <div class="input-with-copy">
        <input type="text" 
               [value]="token || 'No token available'" 
               readonly 
               [class.no-token]="!token"
               (click)="token && selectText($event)">
        <button mat-raised-button 
                color="primary" 
                [disabled]="isRegeneratingToken"
                (click)="token ? copyToClipboard(token) : null">
          <mat-spinner *ngIf="isRegeneratingToken" diameter="20"></mat-spinner>
          <span *ngIf="!isRegeneratingToken">{{ getTokenButtonText() }}</span>
        </button>
      </div>
      <div class="token-actions">
        <button mat-button 
                color="warn" 
                (click)="regenerateToken()" 
                [disabled]="isRegeneratingToken">
          <mat-icon>refresh</mat-icon>
          Regenerate Token
        </button>
      </div>
      <div *ngIf="tokenRegenerationError" class="error-message">
        <mat-icon>error</mat-icon>
        {{ tokenRegenerationError }}
      </div>
    </div>
  </div>

  <div class="warning-section">
    <mat-icon>warning</mat-icon>
    <div class="warning-content">
      <strong>Important:</strong>
      <p>Regenerating the token will invalidate the current token. Update your applications with the new token immediately.</p>
    </div>
  </div>
</div>
